import React, { Component, Fragment } from 'react'

import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Client Id',
    dataIndex: 'clientId',
    sorter: (a, b) => a.clientId.localeCompare(b.clientId)
  },
  {
    title: 'Reader SN',
    dataIndex: 'readerSn',
    sorter: (a, b) => a.readerSn.localeCompare(b.readerSn)
  },
  {
    title: 'Port Number',
    dataIndex: 'portNumber',
    sorter: (a, b) => a.portNumber.localeCompare(b.portNumber)
  },
  {
    title: 'Site Id',
    dataIndex: 'siteId',
    sorter: (a, b) => a.siteId.localeCompare(b.siteId)
  },
  {
    title: 'Zone Id',
    dataIndex: 'zoneId',
    sorter: (a, b) => a.zoneId.localeCompare(b.zoneId)
  },
  {
    title: 'Active',
    dataIndex: 'active',
    render: active => (active ? 'Active' : 'Deactivated'),
    sorter: (a, b) => a.active.localeCompare(b.active)
  }
]

const ListViewAntennas = ({ antennas }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {antennas.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {antennas.length} antennas
      </PageContentUnderTitle>
    )}
    <Table dataSource={antennas} columns={columns} pagination={false} />
  </div>
)

export default ListViewAntennas



// WEBPACK FOOTER //
// ./src/pages/summary/summary-list/components/list-view-antennas/index.js